import React from 'react';
import './style.scss';
import ArrowButton from './arrowButton';
import clsx from 'clsx';

interface Props {
  handleLeft: () => void;
  handleRight: () => void;
  inactive: boolean;
  className?: string;
}

const MarketPageArrows = ({
  handleLeft,
  handleRight,
  inactive,
  className
}: Props) => (
  <div className={clsx('market-page-arrows', className)}>
    <ArrowButton
      direction='left'
      className='market-page-arrow'
      onClick={inactive ? undefined : handleLeft}
    />
    <ArrowButton
      direction='right'
      className='market-page-arrow'
      onClick={inactive ? undefined : handleRight}
    />
  </div>
);

export default MarketPageArrows;
